
/* injects from baggage-loader */

export const perguntas = [
['<strong>1 aldeão</strong> do oeste consegue colher <strong>',
' laranjas</strong>. ',
'Quantas laranjas conseguirão colher <strong> ',
' aldeões</strong>?'],
['Em <strong>1 caixote</strong> de frutas, cabem <strong>',
' caixas</strong>. ',
'Em cada caixa, cabem <strong>',
' frutas</strong>. ',
'Quantas frutas cabem em <strong>3 caixotes</strong>?']
];

export const palavras = [
'aldeões',
'laranjas',
'caixotes',
'caixas',
'frutas'
];

import aldeaoMenor from "_images/tela-de-desafio/icons/aldeao.png";
import laranja from "_images/tela-de-desafio/icons/fruta.png";

export const elements1 = [
{
	type: "aldeão",
	parentStyle: {
		width: '480px',
		height: '200px',
		'justify-content': 'center'	,
		padding: '0px 60px'
	},
	value: 1,
	minValue: 1,
	maxValue: 8,
	icon: 'aldeao',
	iconMenor: aldeaoMenor,
	rate: 1,
	style: {
		width: '80px',
		height: '120px',
		padding: '2px'
	},
	question: false
},
{
	type: "laranja",
	parentStyle: {
		width: '480px',
		height: '200px',
		'justify-content': 'center'	
	},
	value: 1,
	minValue: 1,
	maxValue: 720,
	icon: 'laranja',
	iconMenor: laranja,
	rate: 5,
	style: {
		width: '80px',
		height: '80px',
		padding: '2px'
	},
	question: true
}];

import caixote from "_images/tela-de-desafio/icons/caixote.png";
import caixa from "_images/tela-de-desafio/icons/caixa.png";

export const elements2 = [
{
	type: "caixote",
	parentStyle: {
		width: '350px',
		height: '160px',
		'justify-content': 'center'	,
	},
	value: 1,
	minValue: 1,
	maxValue: 3,
	icon: 'caixote',
	iconMenor: caixote,
	rate: 1,
	style: {
		width: '80px',
		height: '80px',
		padding: '2px'
	},
	question: false,
	secondQuestion: false
},
{
	type: "caixa",
	parentStyle: {
		width: '350px',
		height: '160px',
		'justify-content': 'center'	,
	},
	value: 1,
	minValue: 1,
	maxValue: 45,
	icon: 'caixa',
	iconMenor: caixa,
	rate: 1,
	style: {
		width: '80px',
		height: '80px',
		padding: '2px'
	},
	question: false,
	secondQuestion: true
},
{
	type: "laranja",
	parentStyle: {
		width: '350px',
		height: '160px',
		'justify-content': 'center'	
	},
	value: 1,
	minValue: 1,
	maxValue: 450,
	icon: 'laranja',
	iconMenor: laranja,
	rate: 1,
	style: {
		width: '80px',
		height: '80px',
		padding: '2px'
	},
	question: true,
	secondQuestion: true
}];



// WEBPACK FOOTER //
// ./src/app/pages/stage-one/stage-one.const.js